import React, { useEffect, useState } from 'react'
import { getCart, updateCart, deleteCart } from '../../Redux/ActionCreator/CartActionCreator'
import { getProduct, updateProductQuantity } from '../../Redux/ActionCreator/ProductActionCreator'
import { createCheckout } from '../../Redux/ActionCreator/CheckoutActionCreator'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
export default function CartSection(props) {
    let [cart, setCart] = useState([])
    let [subtotal, setSubTotal] = useState(0)
    let [cartitem, setCartItem] = useState(0)
    let [shipping, setShipping] = useState(0)
    let [total, setTotal] = useState(0)
    let [mode, setMode] = useState("Case on delivery")
    let dispatch = useDispatch()
    let navigate = useNavigate()
    let CartStateData = useSelector(state => state.CartStateData)
    let ProductStateData = useSelector(state => state.ProductStateData)

    function placeOrder() {
        let item = {
            user: localStorage.getItem("userid"),
            orderStatus: "Order Confirmed",
            paymentMode: mode,
            paymentStatus: "Pending",
            subtotal: subtotal,
            shipping: shipping,
            total: total,
            date: new Date(),
            products: cart
        }
        dispatch(createCheckout(item))

        for (let item of cart) {

            let product = ProductStateData.find((x) => x._id === item.product?._id)
            product.stockQuantity = product.stockQuantity - item.qty
            product.stock = product.stockQuantity === 0 ? false : true

            let productItem = {
                _id: product._id,
                stockQuantity: product.stockQuantity,
                stock: product.stock
            }

            dispatch(updateProductQuantity(productItem))
            dispatch(deleteCart({ _id: item._id }))
        }
        setTimeout(() => {
            if (mode === "Case on delivery") {
                navigate("/confirmation");
            } else {
                navigate("/payment/-1");
            }
        }, 0);
    }

    function calculate(data) {
        let sum = 0
        for (let item of data) {
            sum = sum + item.total
        }
        setSubTotal(sum)
        setShipping(sum > 0 && sum < 1000 ? 40 : 0)
        setTotal(sum > 0 && sum < 1000 ? sum + 40 : sum)
    }

    function deleteItem(_id) {
        if (window.confirm("Are You really want to remove that item from cart")) {
            dispatch(deleteCart({ _id: _id }))
            getAPIData()
        }
    }

    function updateItem(_id, option) {
        let item = cart.find((x) => x._id === _id)
        let index = cart.findIndex(x => x._id === _id)
        if (item) {
            if (option === "Dec" && item.qty === 1)
                return
            else if (option === "Dec") {
                item.qty = item.qty - 1;
                item.total = item.total - item.product?.finalPrice
            }
            else {
                if (item.qty < item.product?.stockQuantity) {
                    item.qty = item.qty + 1;
                    item.total = item.total + item.product?.finalPrice
                }
            }
            dispatch(updateCart({ ...item }))
            cart[index].qty = item.qty
            cart[index].total = item.total
            calculate(cart)
        }
    }

    function getAPIData() {
        dispatch(getCart())
        if (CartStateData.length) {
            let data = CartStateData
            setCart(data);
            calculate(data)
            setCartItem(CartStateData.length)

        }
        else
            setCart([])
    }

    useEffect(() => {
        getAPIData()
    }, [CartStateData.length])

    useEffect(() => {
        (() => {
            dispatch(getProduct())
        })()
    }, [ProductStateData.length])

    return (
        <>
            <div className="container mt-4">
                <div className="row">
                    <div className={`${cart.length ? "col-md-8" : "col-md-12"}`}>
                        <div className="testimonial-item img-border-radius shadow-sm bg-white p-4 mb-3">
                            {
                                cart.length ?
                                    cart.map((item, index) => {
                                        return <> <div key={index} className="row">
                                            <div className="col-md-4">
                                                <Link to={`/product/${item?.product?._id}`}><img src={`/${item.product?.pic}`} height={150} width="50%" alt="" /></Link>
                                            </div>
                                            <div className='col-md-8'>
                                                <div className='d-flex justify-content-between'>
                                                    <div className='mt-2'><p>{item.product?.name.slice(0, 20) + "..."}<span className='border rounded-pill px-2 mx-2' style={{ fontSize: "12px" }}>Brand:{item.product?.brand?.name}</span></p>
                                                        <p className='extra' style={{ fontSize: "14px" }}>{item.product?.maincategory?.name}, {item.product?.color}, {item.product?.size}</p>
                                                        <p className='extra'><del>&#8377; {item.product?.basePrice}</del> &#8377; {item.product?.finalPrice}<sup className='text-success'> {item.product?.discount}% Off</sup></p>
                                                    </div>
                                                    <div className='mt-2 total-price'>
                                                        <span><strong>Total_Price</strong><p><strong>&#8377;</strong> {item.total}</p></span>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                            <div className='d-flex align-items-center gap-4 border-bottom my-2'>
                                                {props.title === "Cart" ?
                                                    <div className="d-flex gap-2 align-items-center m-3 quantity" >
                                                        <div className="input-group-btn">
                                                            <button className="btn btn-sm btn-minus rounded-circle bg-white border" onClick={() => updateItem(item._id, "Dec")}>
                                                                <i className="fa fa-minus"></i>
                                                            </button>
                                                        </div>
                                                        <input type="text" className="form-control form-control-sm text-center border-1" value={item.qty} style={{ width: "50px" }} />
                                                        <div className="input-group-btn ">
                                                            <button className="btn btn-sm btn-plus rounded-circle bg-white border" onClick={() => updateItem(item._id, "Inc")}>
                                                                <i className="fa fa-plus"></i>
                                                            </button>
                                                        </div>
                                                    </div> : ""
                                                }
                                                {props.title === "Cart" ? <p className='btn text-danger mb-0' onClick={() => deleteItem(item._id)}><i className='fa fa-trash'></i> Remove</p> : ""}
                                            </div>
                                        </>
                                    }) :
                                    <div className='text-center'>
                                        <img src="./img/shopcart.png" height={300} alt="" />
                                        <h5>{props.title === "Cart" ? "Your Cart is Empty" : "No item for Checkout"}</h5>
                                        <Link to="/shop" className='btn btn-info '>Shop Now</Link>
                                    </div>
                            }
                        </div>
                    </div>
                    {
                        cart.length ?
                            <div className="col-md-4">
                                <div className="testimonial-item img-border-radius shadow-sm bg-white pb-2">
                                    <h5 className='px-4 pt-4'>Price Details</h5>
                                    <hr />
                                    <div className='px-4'>
                                        <p>Subtotal <span className='float-end'>&#8377;{subtotal}</span></p>
                                        <p>Items <span className='float-end'>{cartitem}</span></p>
                                        <p>Delivery Charge <span className='float-end'>{shipping ? `₹${shipping}` : "Free"}</span></p>
                                        {props.title === "Checkout" ?
                                            <p>Payment Mode <span className='float-end'>
                                                <select onChange={(e) => {
                                                    setMode(e.target.value);
                                                }} name="mode" className='px-1 ms-2 border-dark rounded'>
                                                    <option value="Case on delivery">Cash on delivery</option>
                                                    <option value="Net Banking">Net Banking</option>
                                                </select>
                                            </span></p> :
                                            ""
                                        }
                                        <h6 className='py-2' style={{ border: "dotted", borderLeft: 0, borderRight: 0 }}>Total Amount <span className='float-end'>&#8377;{total}</span></h6>
                                        {props.title === "Cart" ?
                                            <Link to='/checkout' className='btn btn-info w-100 mt-1'>Process To Checkout</Link> :
                                            <Link className='btn btn-info w-100 mt-1' onClick={placeOrder}>Place Order</Link>
                                        }
                                    </div>
                                </div>
                            </div> : ""
                    }
                </div>
            </div>
        </>
    )
}
